import { useState } from 'react'

import { PackageCard, packageCartKeys } from '@/components/quotes/PackageCard'
import { Cap } from '../../primitives'
import { PACKAGE } from './packageCardData'

const IN_CART_KEYS: ReadonlySet<string> = new Set(packageCartKeys(PACKAGE))

/** Not in cart on the left — click to add, Remove to undo — and in cart on the right. */
export function PackageCardDemo() {
  const [cartKeys, setCartKeys] = useState<ReadonlySet<string>>(() => new Set())

  const add = (keys: string[]) => setCartKeys((current) => new Set([...current, ...keys]))
  const remove = (keys: string[]) =>
    setCartKeys((current) => new Set([...current].filter((key) => !keys.includes(key))))

  return (
    <div className="grid items-start gap-4 lg:grid-cols-2">
      <div className="flex flex-col gap-2">
        <Cap>package, interactive</Cap>
        <PackageCard
          quotePackage={PACKAGE}
          cartKeys={cartKeys}
          onAddCoverages={add}
          onRemoveCoverages={remove}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Cap>package, in cart</Cap>
        <PackageCard quotePackage={PACKAGE} cartKeys={IN_CART_KEYS} />
      </div>
    </div>
  )
}
